"use client"

import React from "react"
import { Button } from "@/components/ui/button"

interface AnswerRecord {
  questionText: string // 概要
  userChoiceName: string // ユーザーが選択した住宅名
  isCorrect: boolean
  correctName: string // 正解の住宅名
}

interface QuizResultProps {
  score: number
  total: number
  userAnswers: AnswerRecord[]
  onReset: () => void
}

export function QuizResult({
  score,
  total,
  userAnswers,
  onReset,
}: QuizResultProps) {
  return (
    <div className="space-y-4">
      <div className="text-center">
        <p>お疲れさまでした！</p>
        <p>
          あなたの正解数は <strong>{score}</strong> / {total} です。
        </p>
      </div>

      {/* 全問題の回答一覧表 */}
      <div className="overflow-x-auto">
        <table className="w-full border border-collapse text-sm">
          <thead>
            <tr className="bg-gray-100">
              <th className="border px-2 py-1">問題文（概要）</th>
              <th className="border px-2 py-1">選択した回答</th>
              <th className="border px-2 py-1">正誤</th>
              <th className="border px-2 py-1">正解</th>
            </tr>
          </thead>
          <tbody>
            {userAnswers.map((ans, i) => (
              <tr key={i}>
                <td className="border px-2 py-1">{ans.questionText}</td>
                <td className="border px-2 py-1">{ans.userChoiceName}</td>
                <td className="border px-2 py-1">
                  {ans.isCorrect ? "○" : "×"}
                </td>
                <td className="border px-2 py-1">{ans.correctName}</td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <div className="text-center">
        <Button onClick={onReset}>もう一度チャレンジする</Button>
      </div>
    </div>
  )
}
